
const ERROR_LIST = {
    'INIT_EXAM_ERROR': {
        code: "INIT_EXAM_ERROR",
        msg: "Khởi tạo đề thi thất bại, vui lòng liên hệ với quản trị viên!"
    }
}

export default {
    namespaced: true,
    state: {
        appSettings: {
            "start_with": {
                "type": "form_input",
                configs: {
                    form_input: [],
                    ican_connect: {}
                }
            },
            fb_tracking: '',
            theme: ''
        },
        errorCode: '',
        page: 1,
        tracking_id: (() => {
            const tracking = localStorage.getItem('_speakup_track')
            return tracking || null
        })(),
        exam: null,
        part: 0,
        contactInfo: {
            id: -1,
            email: '',
            name: '',
            phone: '',
        },
        loading: false,
        testHistory: {
            id: -1,
            time: {},
            part: 0,
            data: {}
        }
    },
    getters: {
        examID (state) {
            if (state.exam) {
                return state.exam.id
            }

            return null
        },

        getThemeSetting (state) {
            return state.appSettings.theme
        },

        getStartType (state) {
            return state.appSettings.start_with.type || ''
        },

        getError(state) {
            return ERROR_LIST[state.errorCode] || {}
        },

        getStartWith (state) {
            return state.appSettings.start_with.configs
        },

        getContactInfo (state) {
            return state.contactInfo
        }
    },
    mutations: {
        SET_PAGE(state, page) {
            state.page = page;
        },
        SET_PART(state, payload) {
            state.part = payload
            state.exam.partIsUsed = payload
        },
        SET_QUESTIONS(state, payload) {
            state.exam = payload
        },
        SET_CONTACT_INFO(state, payload) {
            state.contactInfo =  Object.assign(state.contactInfo, payload)
            localStorage.setItem('_speakup_userInfo', JSON.stringify(state.contactInfo))
        },
        SET_TRACKING_ID(state, payload) {
            state.tracking_id = payload
            localStorage.setItem('_speakup_track', payload)
        },

        PAGE_LOADING(state, payload) {
            state.loading = payload
        },


        SET_SETTINGS(state, settings) {
            state.appSettings = settings
        },

        SET_HISTORY_ID (state, historyID) {
            state.testHistory.id = historyID
            localStorage.setItem(`_speakup_exam${state.exam.id}`, historyID)
        },


        

        SET_ANSWER(state, payload) {

            const questionIndex = state.exam.part[state.part].questions.findIndex(qs => { return qs.id === payload.id })
            // part_type == 2 câu hỏi dạng speaking.

            if (state.exam.part[state.part].part_type == 2) {
                state.exam.part[state.part].questions[questionIndex].answers = payload
            } else {
                for (let index = 0; index < payload.value.length; index++) {
                    state.exam.part[state.part].questions[questionIndex].answers[index] = payload.value[index];
                }
    
                const chenhlech = state.exam.part[state.part].questions[questionIndex].answers.length - payload.value.length
                if (chenhlech > 0) {
                    state.exam.part[state.part].questions[questionIndex].answers.splice(payload.value.length, chenhlech)
                }
            }
        },



        SET_TIME_REMAINING(state, payload) {
            state.exam.part[state.part].time_remaining = payload
            localStorage.setItem('speakupTestData', JSON.stringify(state.exam))
        },

        SET_VIDEO_REPLAY_COUNT(state, payload) {
            state.exam.part[state.part].video_replay = payload
            localStorage.setItem('speakupTestData', JSON.stringify(state.exam))
        },
        SET_WRITING(state, payload) {
            state.exam.part[state.part].writing = payload
            localStorage.setItem('speakupTestData', JSON.stringify(state.exam))
        },

        SET_QUESTION_INDEX(state, payload) {
            state.exam.part[state.part].question_index = payload
            localStorage.setItem('speakupTestData', JSON.stringify(state.exam))
        },
        SET_PART_STEP(state, payload) {
            state.exam.part[state.part].step = payload
            localStorage.setItem('speakupTestData', JSON.stringify(state.exam))
        },
        SET_ERROR (state, payload) {
            state.errorCode = payload
        }
    },
    actions: {
        AuthLogout() {

        },
        userClearInfo ({commit}) {
            this._vm.$cookie.delete('access_token')
            commit('SET_CONTACT_INFO', {
                id: -1,
                email: '',
                name: '',
                phone: '',
            })
        },

    }
}